var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTowerDenied = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M20.86 6.744c0 1.516-.209 2.745-1.497 2.745-1.497 0-1.497-1.23-1.497-2.745C17.866 5.227 19.363 4 19.363 4s1.497 1.23 1.497 2.744zm-5.233 12.194a8.143 8.143 0 0 0-.542-1.628c.463.289.953.535 1.464.734l-.922.894zm7.219 3.594c.067 4.599 1.564 9.905 2.44 12.047-.263.818-2.232 1.421-3.224 1.421h-5.33c-.99 0-2.96-.603-3.222-1.421a33.3 33.3 0 0 0 1.329-4.283l8.007-7.764z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M17.537 17.084c-3.529-.874-6.157-4.225-6.157-8.229a8.865 8.865 0 0 1 .718-3.504c1.259 2.92 4.038 4.949 7.266 4.949 3.227 0 6.003-2.03 7.265-4.949.316.736.53 1.51.636 2.3l-9.728 9.433z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M32.59 4.362 36 7.667 7.408 35.39l-3.409-3.305L32.591 4.362z"
})));
export default SvgTowerDenied;